export default () => ({
  restrict: 'A',
  require: 'ngModel',
  link: (scope, element, attrs, ngModel) => {
    ngModel.$validators.validatorNames = value => /^([а-яА-ЯЁё-]+)$/.test(value);
  },
});
